import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/linkedin': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 32H31.9C14.3 32 0 46.5 0 64.3V447.7C0 465.5 14.3 480 31.9 480H416C433.6 480 448 465.5 448 447.7V64.3C448 46.5 433.6 32 416 32zM135.4 416H69V202.2H135.5V416zM102.2 173C80.9 173 63.7 155.7 63.7 134.5S80.9 96 102.2 96C123.4 96 140.7 113.3 140.7 134.5 140.7 155.8 123.5 173 102.2 173zM384.3 416H317.9V312C317.9 287.2 317.4 255.3 283.4 255.3 248.8 255.3 243.5 282.3 243.5 310.2V416H177.1V202.2H240.8V231.4H241.7C250.6 214.6 272.3 196.9 304.6 196.9 371.8 196.9 384.3 241.2 384.3 298.8V416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linkedin.js
// module id = dkLc
// module chunks = 144